import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { checkBrowserStatus, BrowserCompatibilityHeadbandComponent } from '@le_cedre/portal-lib';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { environment } from '@env/environment';
import { NgIf, NgStyle } from '@angular/common';

@Component({
    selector: 'app-portal-login',
    template: `
        <portal-browser-compatibility-headband
            *ngIf="checkBrowserStatus() === 'Degraded'"
        ></portal-browser-compatibility-headband>
        <div
            class="portal-login login-background-img"
            [class.reset-password__page]="isResetPasswordPage"
            [ngStyle]="{ 'background-image': 'url(' + commonStatic + 'img/group.webp)' }"
        >
            <div class="portal-login__header">
                <div class="logo"></div>
            </div>
            <router-outlet></router-outlet>
        </div>
    `,
    styleUrls: ['./login.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [NgIf, BrowserCompatibilityHeadbandComponent, NgStyle, RouterOutlet],
})
export class LoginComponent implements OnInit, OnDestroy {
    isResetPasswordPage: boolean;
    commonStatic: string = environment.urls.commonStatic;
    checkBrowserStatus = checkBrowserStatus;

    private destroyed$ = new Subject();

    constructor(private activeRoute: Router) {}

    ngOnInit(): void {
        this.isResetPasswordPage = this.activeRoute.url.includes('password/reset');
        this.activeRoute.events
            .pipe(
                takeUntil(this.destroyed$),
                filter((e): e is NavigationEnd => e instanceof NavigationEnd)
            )
            .subscribe((routerSnapshot) => {
                this.isResetPasswordPage = routerSnapshot.url.includes('password/reset');
            });
    }

    ngOnDestroy(): void {
        this.destroyed$.next(null);
        this.destroyed$.complete();
    }
}
